var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFavoritos = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "D7391443-C5A6-41A2-ADFC-10F76E648CCB")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-",
    transform: "translate(-20.000000, -286.000000)",
    fill: "#4B4B4A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Copy-5",
    transform: "translate(0.000000, 276.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Menu-/-Banners",
    transform: "translate(20.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7807779,7.70606061 C19.4813839,6.76969697 17.8335051,6.55575758 16.0886567,6.32484848 C15.132293,6.19939394 14.0456264,6.05757576 13.7177476,5.81454545 C13.3874445,5.57333333 12.9268385,4.58121212 12.5195657,3.70424242 C11.7789597,2.10969697 11.0777476,0.605454545 10.0971415,0.603030303 L10.0789597,0.6 C9.10683847,0.616363636 8.39835362,2.10242424 7.64502029,3.68 C7.22986878,4.55212121 6.75774756,5.54060606 6.42865665,5.78 C6.09592938,6.0169697 5.00926271,6.15030303 4.04986878,6.26666667 C2.30683847,6.47878788 0.656535442,6.67757576 0.348656654,7.60909091 C0.0407778663,8.54060606 1.24502029,9.68545455 2.52138393,10.8951515 C3.22198999,11.5606061 4.01532332,12.3145455 4.14017181,12.7024242 C4.26502029,13.090303 4.05350514,14.1666667 3.86865665,15.1127273 C3.53047484,16.8363636 3.2110809,18.4684848 4.00138393,19.0521212 C4.19047484,19.1872727 4.42805059,19.2557576 4.70865665,19.249697 C5.51532332,19.2369697 6.67592938,18.6090909 7.79774756,18.0006061 C8.63835362,17.5412121 9.59168696,17.0230303 10.0159294,17.0181818 C10.4262324,17.0181818 11.382596,17.5509091 12.2262324,18.0206061 C13.3735051,18.6575758 14.5607779,19.3169697 15.3686567,19.3036364 C15.6207779,19.3 15.8359294,19.2351515 16.011687,19.1084848 C16.8068385,18.5357576 16.5038082,16.9042424 16.1844142,15.1739394 C16.0086567,14.2260606 15.811687,13.1472727 15.9359294,12.7593939 C16.0644142,12.3733333 16.8668385,11.6290909 17.5741112,10.9684848 C18.86199,9.77030303 20.0777476,8.64242424 19.7807779,7.70606061 Z",
    id: "Path"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFavoritos, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/favoritos.0982b9b1.svg";
export { ForwardRef as ReactComponent };